export default "__VITE_ASSET__xwF2XANL__"